import type { ActionButtonType } from "./action-button.type";

import {
  CopyOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  InfoCircleOutlined,
  PlusOutlined,
  UserAddOutlined,
} from "@ant-design/icons";

export const getActionButtonIcon = (action: ActionButtonType) => {
  switch (action) {
    case "assign":
      return <UserAddOutlined />;
    case "create":
      return <PlusOutlined />;
    case "delete":
      return <DeleteOutlined />;
    case "duplicate":
      return <CopyOutlined />;
    case "edit":
      return <EditOutlined />;
    case "export":
      return <DownloadOutlined />;
    case "info":
      return <InfoCircleOutlined />;
    case "view":
      return <InfoCircleOutlined />;
    default:
      return null;
  }
};
